import AdminUsersGet from './AdminUsersGet';

export default AdminUsersGet;
